import ImageGallery from "react-image-gallery";
import { useCallback, useRef } from "react";
import { Close } from "../../../../Icons";
import { useSelector } from "react-redux";
import { selectSiteLang } from "../../../../../store/userSlice";
import "react-image-gallery/styles/css/image-gallery.css";
import style from "./index.module.css";

const Gallery = ({ gallery, galleryType }: ComponentPropsType) => {
  const siteLang = useSelector(selectSiteLang);
  const viewerRef = useRef<HTMLDivElement>(null);

  const onToggleViewerHandler = useCallback(
    (e, close: boolean = false) => {
      if (viewerRef.current) {
        if (viewerRef.current.classList.contains(style.active) && close) {
          viewerRef.current.classList.remove(style.active);
        } else {
          viewerRef.current.classList.add(style.active);
        }
      }
    },
    [viewerRef],
  );

  return (
    <>
      <div
        className={`${style.images} ${
          galleryType === "grid" ? style.grid : galleryType === "square" ? style.square : style.single
        }`}
      >
        {galleryType === "single" ? (
          <img onClick={onToggleViewerHandler} className={style.single_image} src={gallery[0]} alt="" />
        ) : (
          gallery.map((image, index) => (
            <img key={index} onClick={onToggleViewerHandler} className={style.single_image} src={image} alt="" />
          ))
        )}
      </div>
      <div className={style.images_view} ref={viewerRef}>
        <div className={style.images_view__content}>
          <button className={style.images_view__close} onClick={(e) => onToggleViewerHandler(e, true)} type="button">
            <Close height="16" width="16" color="#fff" />
          </button>
          <ImageGallery
            lazyLoad={true}
            items={gallery.map((image) => ({
              original: image,
              thumbnail: image,
            }))}
            showPlayButton={false}
            showFullscreenButton={false}
            isRTL={siteLang === "ar" ? true : false}
          />
        </div>
      </div>
    </>
  );
};

export default Gallery;

export type GalleryType = string[];

type ComponentPropsType = {
  gallery: GalleryType;
  galleryType: "grid" | "square" | "single";
};
